import { FormattedMessage, useIntl } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import messages from '../CompanyDetails.messages';

const WebsiteQuestion = (props) => {
    const intl = useIntl();
    const { onChange } = props;

    return (
        <FormField
            label={<FormattedMessage {...messages.website} />}
            className="fs-exclude"
            name="website"
            id="website"
            onChangeHandler={onChange}
            placeholder={intl.formatMessage(messages.websitePlaceholder)}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default WebsiteQuestion;
